import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"

import { ProductOriginGridHeader } from "@/screens/Products/components/Product/Information/Origin/ProductOriginGridHeader"
import { ProductOriginGridValues } from "@/screens/Products/components/Product/Information/Origin/ProductOriginGridValues"

interface ProductOriginGridProps {
  shippingOrigin: {
    address: string
    country: string
    city: string
  }
  manufacturingOrigin: {
    country: string
    region: string
    city: string
    address: string | null
  }
  countryOrigin: {
    country: string
    region: string
    city: string
    address: string | null
  }
  onEdit: () => void
  isPastProductVersion: boolean
}

export const ProductOriginGrid = ({
  shippingOrigin,
  manufacturingOrigin,
  countryOrigin,
  onEdit,
  isPastProductVersion,
}: ProductOriginGridProps): ReactElement => {
  return (
    <TableContainer data-testid='product-origin-grid'>
      <Table>
        <TableHead>
          <TableRow sx={{ ".MuiTableCell-head": { borderBottom: 0 } }}>
            <TableCell className='bg-gray-300' data-testid='shipping-origin-header'>
              Shipping Origin
            </TableCell>
            <TableCell className='bg-gray-200' colSpan={3} data-testid='country-origin-header'>
              Country of Origin
            </TableCell>
            <TableCell colSpan={4} data-testid='manufacturing-origin-header'>
              Manufacturing Location
            </TableCell>
          </TableRow>
          <TableRow sx={{ ".MuiTableCell-head": { backgroundColor: "white", borderRadius: "0 !important" } }}>
            <TableCell data-testid='ship-from-label'>Ship From</TableCell>
            <ProductOriginGridHeader address={countryOrigin.address} testIdPrefix='country-origin' />
            <ProductOriginGridHeader address={manufacturingOrigin.address} testIdPrefix='manufacturing-origin' />
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell data-testid='shipping-origin-address'>{shippingOrigin.address || "-"}</TableCell>
            <ProductOriginGridValues productOrigin={countryOrigin} testIdPrefix='country-origin' />
            <ProductOriginGridValues productOrigin={manufacturingOrigin} testIdPrefix='manufacturing-origin' />
            <TableCell align='right' data-testid='edit-button-container'>
              {!isPastProductVersion && (
                <IconButton onClick={onEdit} color='primary' data-testid='edit-button' aria-label='Edit product origin'>
                  <EditOutlined />
                </IconButton>
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
